import { render, staticRenderFns } from "./SuggestDoctorLoadingTestimonials.vue?vue&type=template&id=00a669a6&scoped=true"
import script from "./SuggestDoctorLoadingTestimonials.vue?vue&type=script&lang=js"
export * from "./SuggestDoctorLoadingTestimonials.vue?vue&type=script&lang=js"
import style0 from "./SuggestDoctorLoadingTestimonials.vue?vue&type=style&index=0&id=00a669a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a669a6",
  null
  
)

export default component.exports